import React from "react";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import AxiosService from "utils/AxiosService";
import {
  addComboPack,
  updateComboPack as updateComboPackAction,
  addAllComboPacks,
  deleteComboPack as deleteComboPackAction,
} from "Redux/Reducer/ComboPackReducer";

function UseComboPackHook() {
  const dispatch = useDispatch();

  const createComboPack = async (data) => {
    try {
      // console.log("Creating ComboPack with data:", data);
      const res = await AxiosService.post("/vendor/createComboPack", data);
      if (res.status === 201) {
        toast.success(res.data.message);
        dispatch(addComboPack(res?.data?.data));
      }
    } catch (error) {
      console.error("Create ComboPack Error:", error);
      toast.error(error?.response?.data?.message || "Failed to create combo pack");
    }
  };

  const getAllComboPacks = async () => {
    try {
      const res = await AxiosService.get("/vendor/getVendorCombos");
      // console.log("Get ComboPacks Response:", res.data.data);
      if (res.status === 200) {
        dispatch(addAllComboPacks(res?.data?.data));
        return res.data.data;
      }
    } catch (error) {
      console.error("Get ComboPacks Error:", error);
      toast.error("Failed to load combo packs");
    }
  };

  const updateComboPack = async (id, data) => {
    try {
      // console.log("Updating ComboPack with data:", data);
      const res = await AxiosService.put(`/vendor/updateComboPack/${id}`, data);
    //   console.log("Update ComboPack Response:", res.data);
      if (res.status === 200) {
        toast.success(res.data.message);
        dispatch(updateComboPackAction(res?.data?.data));
      }
     
    } catch (error) {
      console.error("Update ComboPack Error:", error);
      toast.error(error?.response?.data?.message||"Failed to update combo pack");
    }
  };

  const deleteComboPack = async (id) => {
    try {
      const res = await AxiosService.delete(`/vendor/deleteComboPack/${id}`);
      if (res.status === 200) {
        toast.success(res.data.message);
        dispatch(deleteComboPackAction(id));
      }
    } catch (error) {
      console.error("Delete ComboPack Error:", error);
      toast.error("Failed to delete combo pack");
    }
  };

  return {
    createComboPack,
    getAllComboPacks,
    updateComboPack,
    deleteComboPack,
  };
}

export default UseComboPackHook;
